const animations = {
  timings: {
    slow: '500ms',
    medium: '300ms',
    fast: '150ms'
  },
  easings: {
    standard: 'ease',
    cubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
  }
};

export { animations, animations as default };
//# sourceMappingURL=Animations.js.map
